import isEmpty from 'lodash/isEmpty';

/**
 * Parses an inline CSS string (e.g. `"color: red; font-size: 12px"`) into a key-value record
 * mapping CSS property names to their values. Returns `undefined` if the input is empty or
 * does not match the expected inline style format.
 */
export const parseInlineCSS = (inlineCss: string): Record<string, string> | undefined => {
    if (!inlineCss) {
        return undefined;
    }

    // Should follow the pattern `property-name: value;` except for
    // the last property of the string, that can end without `;`
    const isInlineStyle = !!inlineCss.match(/^(\s*[\w-]+\s*:[^;]+(;\s*|$))+$/i);

    if (!isInlineStyle) {
        return undefined;
    }

    let cssObject: Record<string, string> = {};
    const styleValues = inlineCss.split(/\s*;\s*/g);
    for (const styleValue of styleValues) {
        const cssProperty = styleValue.match(/^([^\s:]+)\s*:\s*(.+)/);
        if (cssProperty) {
            const [, property, value] = cssProperty;

            cssObject = { ...cssObject, [property]: value };
        }
    }

    return isEmpty(cssObject) ? undefined : cssObject;
};
